// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COVID19_WARNING__NAME = "Koronavirus";
export const COVID19_WARNING__STAYHOME = "Z\u016fsta\u0148te doma, zpomal\u00edte epidemii!";
export const COVID19_WARNING__WIKILINK = "/zdravi/koronavirus-je-tady-zustante-doma-a-zpomalite-epidemii/";
export const FORUM_READ_MORE = "\u010cti d\u00e1l...";
